module.exports = __webpack_public_path__ + "static/img/4-2b.c69f0280.png";